<span
	[style.background]="color"
	[cpToggle]="true"
	[cpDialogDisplay]="'inline'"
	[(colorPicker)]="color"
	(colorPickerChange)="onColorChange()"
	[cpDisableInput]="true"
	[cpOutputFormat]="'hex'"
></span>
